import React from 'react';
import * as S from './styles';
import { isNullUndefined } from '@/main/services/utils';
import ButtonDemo from '../buttonDemo/buttonDemo';
type IImageProps = {
  clipBorderImage?: S.IClipBorderImage;
  height?: string;
  width?: string;
};
interface ITextImageProps {
  backgroundImage: string;
  title: string;
  description: string;
  positionImage: 'left' | 'right';
  icon?: React.ReactNode;
  imageProps?: IImageProps;
  idImage?: string;
  showButton?: boolean;
  subTitle?: string;
  sizeText?: 'medium' | 'large';
  isWithPadding?: boolean;
}

function TextImage({
  backgroundImage,
  description,
  title,
  positionImage,
  icon,
  imageProps,
  idImage,
  showButton,
  subTitle,
  sizeText = 'large',
  isWithPadding = true
}: ITextImageProps) {
  if (isNullUndefined(showButton)) showButton = false;
  return (
    <S.Container
      $positionImage={positionImage}
      $isWithPadding={isWithPadding}
    >
      <S.AreaText>
        {!isNullUndefined(subTitle) && <S.SubTitleSection data-aos='fade-up'>{subTitle}</S.SubTitleSection>}
        {!isNullUndefined(icon) && <S.Icon data-aos='fade-up'>{icon}</S.Icon>}
        <S.Title $sizeText={sizeText} data-aos='fade-up'>
          {title}
          <br />
          {showButton && <ButtonDemo />}
        </S.Title>
        <S.Description
          $sizeText={sizeText}
          data-aos='fade-up'
          data-aos-delay='100'
        >
          {description}
        </S.Description>
      </S.AreaText>
      <S.AreaImage
        $positionImage={positionImage}
        data-aos='fade-up'
        data-aos-delay='200'
      >
        <S.Image
          id={idImage}
          $clipBorderImage={imageProps?.clipBorderImage}
          src={backgroundImage}
          $height={imageProps?.height}
          $width={imageProps?.width}
          alt=""
        />
      </S.AreaImage>
    </S.Container>
  );
}

export default TextImage;
